module.exports = __webpack_public_path__ + "img/5.a14d3457.jpg";